$( window ).on("zg.product.addedToCart" , function( event, data, product ){
	var priceSell = product.price.sell;
	var currency = product.price.currency;
	var content_ids = product.id;
	console.log('AddToCart');
	fbq('track', 'AddToCart',  { value: priceSell, currency: currency, content_ids: content_ids, content_type: 'product_group' });
});

$( window ).on("zg.product.addedToWishlist" , function(e){
	console.log('AddToWishlist');
	fbq('track', 'AddToWishlist');
});

$( document ).on("click", '[data-zg-role="fbq-checkout-start"]' , function(e){
	console.log('InitiateCheckout');
	fbq('track', 'InitiateCheckout');
});

$( document ).on("change", '[data-zg-role="payments"] input[type=radio]' , function(e){
	console.log('AddPaymentInfo');
	fbq('track', 'AddPaymentInfo');
});

$( document ).ready(function() {
	
	if ( $('[data-zg-role="fbq-track"]').length){
		
		var $element = $('[data-zg-role="fbq-track"]');
		var event = $element.data('event');
		
		if( typeof( fbq ) != "undefined" ){
			
			if (event == 'ViewContent') {
				var ids = $element.data('ids');
				console.log('ViewContent');
				fbq('track', 'ViewContent', { content_ids: ids, content_type: 'product_group' });
			}
 
			if (event == 'Lead') {
				console.log('Lead');
				fbq('track', 'Lead');
			}

			if (event == 'CompleteRegistration') {
				console.log('CompleteRegistration');
				fbq('track', 'CompleteRegistration');
			}

			if (event == 'Purchase') {
				var total = $element.data('value');
				var currency = $element.data('currency');
				var ids = $element.data('ids');
				console.log(total);
				console.log(currency);
				console.log(ids);
				console.log('Purchase');
				fbq('track', 'Purchase', { value: total, currency: currency, content_ids: ids, content_type: 'product_group' });
			}
			
		}
		
	}
   
});




